import React, { useEffect, useMemo } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { fetchEmployees } from "services/dropdown";
import { DROPDOWN_STALE_TIME } from "utils/constants";
import { Controller } from "react-hook-form";

const EmployeeDropdown = ({ errors, control, setValue, getValues, watch, rowData, onChange }) => {
  const selectedEmployeeId = watch("employee_id");

  const employeeName =
    rowData?.employee_obj?.employee_name ||
    rowData?.employee_name ||
    getValues()?.employee_name;

  const {
    data: employees,
    isLoading,
    error,
  } = useQuery(["Employees"], () => fetchEmployees(), {
    keepPreviousData: false,
    staleTime: DROPDOWN_STALE_TIME,
  });

  const modifiedData = useMemo(() => {
    return (
      employees?.data?.data?.map((ele) => ({
        value: ele?.employee_code_id,
        label: ele?.employee_name,
      })) || []
    );
  }, [employees]);

  const options = useMemo(() => modifiedData, [modifiedData]);

  const selectedOption = useMemo(() => {
    return (
      options?.find((option) => option?.value === selectedEmployeeId) ||
      options?.find((option) => option?.label === employeeName) ||
      null
    );
  }, [options, selectedEmployeeId, employeeName]);

  // useEffect(() => {
  //   if (rowData && options?.length) {
  //     const rowDataOption = options?.find(
  //       (option) => option?.value === rowData?.employee_id[0]?.employee_code_id
  //     );
  //     setValue("employee_id", rowDataOption?.value);
  //   }
  // }, [rowData, options, setValue]);

  useEffect(() => {
    if (rowData?.employee_id && Array.isArray(rowData.employee_id) && rowData.employee_id.length > 0 && options?.length) {
      const rowDataOption = options.find(
        (option) => option?.value === rowData?.employee_id[0]?.employee_code_id
      );
      setValue("employee_id", rowDataOption?.value);
    }
  }, [rowData, options, setValue]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Employees</div>;

  return (
    <Controller
      name="employee_id"
      control={control}
      rules={{ required: "Employee is required" }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isClearable
          value={selectedOption || null}
          placeholder="Select Employee"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          // onChange={(selectedOption) => {
          //   const value = selectedOption ? selectedOption?.value : "";
          //   field.onChange(value);
          //   setValue("employee_id", value);
          //   setValue("employee_name", selectedOption ? selectedOption?.label : "");
          // }}
          onChange={(selectedOption) => {
            const value = selectedOption ? selectedOption?.value : "";
            field.onChange(value);
            setValue("employee_id", value);
            setValue("employee_name", selectedOption ? selectedOption?.label : "");

            // Call the onChange prop if it exists
            if (onChange) {
              onChange(selectedOption);
            }
          }}
          className={`react-select-container ${errors?.employee_id ? "is-invalid" : ""
            }`}
        />
      )}
    />
  );
};

export default EmployeeDropdown;